routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.cart', {
      url: "canasta",
      params: {
        from: null
      },
      template: `<cart sh-ctrl="shCtrl"></cart>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/cart/cart.config.js
 **/